// extracted by mini-css-extract-plugin
module.exports = {"quizList":"quizList__g0mC9jmmYVmhP","quizListFooter":"quizListFooter__FfUXoNt2+a7bf","createButton":"createButton__Xcjpj1BT8TB8n","infoButton":"infoButton__8xNSj3KNED8jc"};